import React from 'react';
import { Button } from 'antd';
import { useCarModelPrice } from 'hooks/product-price/car-model-price';
import emiter, { EVENT_VEHICLE_ADD_CAR, EVENT_VEHICLE_TYPE } from '../../../../events';
import SPButton from "../../../carRental/base/SPButton";

interface IComponentProps {
	data?: any;
	permission?: any;
}
const SPTableActionBar: React.FC<IComponentProps> = props => {
	const { data, permission } = props;

	const { tableActionEdit, tableActionView, tableActionAdd } = useCarModelPrice();

	// todo: hard code
	const linkColor = { color: '#1473FF' };

	//从enums删除本身已有状态
	//const newEnums = enums?.filter((item: any) => item.key !== data.packageStatus) || []

	const onEdit = () => {
		tableActionEdit(data);
	};

	const onView = () => {
		tableActionView(data);
	};

	const onAdd = () => {
		emiter.emit(EVENT_VEHICLE_ADD_CAR, data);
		emiter.emit(EVENT_VEHICLE_TYPE, 'new');
		// tableActionAdd(data);
	};

	return (
		<>
			<SPButton permissionKey='car-model-price-view' permission={permission} type="link"  onClick={onView}>
				查看
			</SPButton>
			<SPButton permissionKey='car-model-price-edit' permission={permission} type="link" onClick={onEdit}>
				编辑
			</SPButton>
			<SPButton permissionKey='car-model-price-add-car' permission={permission} type="link" onClick={onAdd}>
				添加车辆
			</SPButton>
		</>
	);
};

export default SPTableActionBar;
